(() => {
  'use strict';
  const script = document.currentScript;
  const words = {enlarge: script?.dataset.enlarge || 'Enlarge photo', smaller: script?.dataset.smaller || 'Reduce photo', fit: script?.dataset.fit || 'Fit photo', gallery: script?.dataset.gallery || 'Review photo viewer', hint: script?.dataset.hint || 'Pinch to zoom. Drag to move. Swipe to change photos when fitted.'};
  const mounted = new WeakSet();
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  function bind(dialog) {
    if (mounted.has(dialog)) return;
    mounted.add(dialog);
    dialog.addEventListener('dblclick', e => e.preventDefault());
    for (const name of ['gesturestart', 'gesturechange']) dialog.addEventListener(name, e => { if (dialog.open) e.preventDefault(); }, {passive: false});
    if (!dialog.classList.contains('finos-photo-dialog')) return;
    const stage = dialog.querySelector('.finos-photo-stage');
    const image = stage?.querySelector('img');
    const previous = stage?.querySelector('.finos-photo-arrow');
    const next = stage?.querySelector('.finos-photo-arrow:last-child');
    const header = dialog.querySelector('.finos-dialog-header');
    if (!stage || !image || !previous || !next || !header) return;
    dialog.classList.add('lc-review-image-overlay');
    const tools = document.createElement('div');
    tools.className = 'lc-lightbox-tools';
    function button(text, label, action) {
      const el = document.createElement('button'); el.type = 'button'; el.textContent = text; el.setAttribute('aria-label', label); el.addEventListener('click', action); tools.append(el); return el;
    }
    let scale = 1, x = 0, y = 0, origin = null, pinch = null, usedPinch = false;
    const points = new Map();
    const minus = button('−', words.smaller, () => zoom(scale / 1.5));
    const plus = button('+', words.enlarge, () => zoom(scale * 1.5));
    button(words.fit, words.fit, reset);
    header.insertBefore(tools, header.lastElementChild);
    const hint = document.createElement('p'); hint.className = 'lc-lightbox-hint'; hint.textContent = words.hint; header.after(hint);
    const counter = header.querySelector('span'); counter?.setAttribute('role', 'status'); counter?.setAttribute('aria-live', 'polite'); counter?.setAttribute('aria-atomic', 'true');
    stage.tabIndex = 0; stage.setAttribute('role', 'region'); stage.setAttribute('aria-label', words.gallery); image.draggable = false;
    function draw() {
      const box = stage.getBoundingClientRect();
      x = clamp(x, -box.width * (scale - 1) / 2, box.width * (scale - 1) / 2);
      y = clamp(y, -box.height * (scale - 1) / 2, box.height * (scale - 1) / 2);
      image.style.transform = `translate3d(${x}px,${y}px,0) scale(${scale})`;
      stage.dataset.zoom = scale.toFixed(2);
      stage.classList.toggle('lc-image-is-zoomed', scale > 1.01);
      minus.disabled = scale <= 1; plus.disabled = scale >= 5;
    }
    function zoom(value) { scale = clamp(value, 1, 5); if (scale === 1) x = y = 0; draw(); }
    function reset() { scale = 1; x = y = 0; points.clear(); origin = pinch = null; usedPinch = false; draw(); }
    function pair() {
      const [a, b] = [...points.values()];
      return {distance: Math.hypot(b.x - a.x, b.y - a.y), cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2};
    }
    stage.addEventListener('pointerdown', e => {
      if (e.button !== 0 || e.target.closest('button')) return;
      points.set(e.pointerId, {x: e.clientX, y: e.clientY});
      stage.setPointerCapture(e.pointerId);
      if (points.size === 1) { origin = {clientX: e.clientX, clientY: e.clientY, x, y}; usedPinch = false; }
      if (points.size === 2) { pinch = {...pair(), scale, x, y}; usedPinch = true; }
    });
    stage.addEventListener('pointermove', e => {
      if (!points.has(e.pointerId)) return;
      e.preventDefault(); points.set(e.pointerId, {x: e.clientX, y: e.clientY});
      if (points.size === 2 && pinch) {
        const p = pair(), box = stage.getBoundingClientRect();
        const nextScale = clamp(pinch.scale * p.distance / Math.max(1, pinch.distance), 1, 5);
        const ratio = nextScale / pinch.scale;
        x = p.cx - (box.left + box.width / 2) - (pinch.cx - (box.left + box.width / 2) - pinch.x) * ratio;
        y = p.cy - (box.top + box.height / 2) - (pinch.cy - (box.top + box.height / 2) - pinch.y) * ratio;
        scale = nextScale; draw();
      } else if (points.size === 1 && scale > 1.01 && origin) {
        x = origin.x + e.clientX - origin.clientX; y = origin.y + e.clientY - origin.clientY; draw();
      }
    });
    function end(e) {
      if (!points.has(e.pointerId)) return;
      if (e.type !== 'pointercancel' && points.size === 1 && !usedPinch && scale <= 1.01 && origin) {
        const dx = e.clientX - origin.clientX, dy = e.clientY - origin.clientY;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          const target = dx < 0 ? next : previous;
          if (!target.hidden && !target.disabled) target.click();
        }
      }
      points.delete(e.pointerId); if (stage.hasPointerCapture(e.pointerId)) stage.releasePointerCapture(e.pointerId);
      pinch = null; const point = [...points.values()][0]; origin = point ? {clientX: point.x, clientY: point.y, x, y} : null;
    }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    stage.addEventListener('wheel', e => { if (dialog.open) { e.preventDefault(); zoom(scale * Math.exp(-e.deltaY * 0.002)); } }, {passive: false});
    stage.addEventListener('keydown', e => { if (e.key === '+' || e.key === '=') { e.preventDefault(); zoom(scale * 1.5); } if (e.key === '-') { e.preventDefault(); zoom(scale / 1.5); } if (e.key === '0') { e.preventDefault(); reset(); } });
    new MutationObserver(reset).observe(image, {attributes: true, attributeFilter: ['src']});
    new MutationObserver(() => { if (dialog.open) reset(); }).observe(dialog, {attributes: true, attributeFilter: ['open']});
    dialog.addEventListener('close', reset); window.addEventListener('resize', draw); reset();
  }
  function scan(root) { if (root.matches?.('.finos-reviews-dialog,.finos-photo-dialog')) bind(root); root.querySelectorAll?.('.finos-reviews-dialog,.finos-photo-dialog').forEach(bind); }
  scan(document);
  new MutationObserver(records => { for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) scan(node); }).observe(document.body, {childList: true});
})();
